import { render, staticRenderFns } from "./adjunto.vue?vue&type=template&id=76e7e940&scoped=true&lang=pug&"
import script from "./adjunto.vue?vue&type=script&lang=js&"
export * from "./adjunto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e7e940",
  null
  
)

export default component.exports